import { useState, useCallback } from 'react';

const useCpraOptOut = () => {
  const [cpraStatus, setCpraStatus] = useState({ success: null, message: '' });

  const handleCpraOptOut = useCallback(async () => {
    try {
      const res = await fetch('/api/privacy/do-not-sell', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await res.json();
      if (data.success) {
        setCpraStatus({
          success: true,
          message: data.message || 'Your opt-out preference has been recorded.',
        });
      } else {
        setCpraStatus({
          success: false,
          message: data.error || 'Failed to record opt-out. Please try again.',
        });
      }
    } catch {
      setCpraStatus({
        success: false,
        message: 'Network error. Please try again later.',
      });
    }
  }, []);

  return { cpraStatus, handleCpraOptOut };
};

export default useCpraOptOut;
